export class InputConfigModel{
    URL: string;
    ClientID?: string;

    constructor(){
        this.URL = "";
        this.ClientID = "0";
    }
}